// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateSelectedLeadAccount = newSelectedLeadAccount => ({
    payload: newSelectedLeadAccount,
    type: actions.UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_LEAD_ACCOUNT
});



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/action-creators/selected-lead-account.js